import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute() {
  const token = localStorage.getItem('token');
  return !token ? <Navigate to='/login' replace /> : <Outlet />;
}

export default ProtectedRoute;
